import styled from 'styled-components';
import { colors } from 'modules/common/styles';

const SortItem = styled.div`
  background: ${colors.colorWhite};
  display: block;
  padding: 5px;
  margin-bottom: 10px;
  z-index: ${props => (props.zIndex ? props.zIndex : 2000)};
  position: relative;
  display: flex;
  justify-content: space-between;
  border-left: 2px solid transparent;
  box-shadow: ${props =>
    props.isDragging ? `0 2px 8px ${colors.shadowPrimary}` : 'none'};
  left: ${props =>
    props.isDragging && props.isModal ? '40px!important' : 'auto'};
  &:last-child {
    margin-bottom: 0;
  }
  &:hover {
    box-shadow: 0 2px 8px ${colors.shadowPrimary};
    border-color: ${colors.colorPrimary};
  }
`;

const SortableWrapper = styled.div`
  width: 100%;
  flex: 1;
  label {
    margin: 0;
  }
`;

const DragHandler = styled.div`
  display: flex;
  width: 20px;
  margin-right: 5px;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  i {
    color: ${colors.colorLightGray};
  }
`;

export { SortItem, SortableWrapper, DragHandler };



// WEBPACK FOOTER //
// ./src/modules/common/styles/sort.js